import React from 'react';

/** 對應 antd 的 md 斷點 —— 小於此寬度視為手機 */
export const MOBILE_MAX_WIDTH = 767;

/**
 * 是否為手機寬度。
 *
 * 用 matchMedia 而非監聽 resize：瀏覽器只在跨越斷點時才通知，不會每移動一像素就重繪。
 * jsdom 沒有實作 matchMedia，測試環境若未補 stub 則一律視為非手機 (維持桌機版面)。
 */
export default function useIsMobile(maxWidth = MOBILE_MAX_WIDTH) {
  const query = `(max-width: ${maxWidth}px)`;

  const [isMobile, setIsMobile] = React.useState(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return false;
    return window.matchMedia(query).matches;
  });

  React.useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;

    const mql = window.matchMedia(query);
    const onChange = (e) => setIsMobile(e.matches);
    setIsMobile(mql.matches);

    // Safari 14 以前只有 addListener，兩種都接以免舊機型失效
    if (mql.addEventListener) {
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    }
    mql.addListener(onChange);
    return () => mql.removeListener(onChange);
  }, [query]);

  return isMobile;
}
